import React, { useEffect, useMemo, useRef, useState } from "react";
import CustomerReport from "./behavior/CustomerReport";
import { Box } from "@mui/material";
import FilterList from "./components/FilterList";
import FilterModal from "./components/FilterModal";
import { StyledFilterBtn } from "./CustomerList.styles";
import { useFetchUserList } from "../redux/fetchUserList";
import axios from "axios";
import { apiUrl } from "features/configure";
import { useOutletContext } from "react-router";
import PopperMenu from "@metacrm/metacrm-material-ui/dist/PopperMenuNew";
import { useIntl } from "react-intl";

export default function CustomerAnalysis() {
  const [openFilter, setOpenFilter] = useState(false);
  const { userListFilter: filter, updateUserListFilter } = useFetchUserList();
  const [entityName] = useOutletContext();
  const [viewList, setViewList] = useState([]);
  const { formatMessage } = useIntl();

  const currentView = useRef({
    name: formatMessage({ id: "global.btn.allItems" }),
    value: "",
  });
  const [update, setUpdate] = useState(0);

  function setCurrentView(view) {
    currentView.current = view;
  }

  const hasFilter = useMemo(() => {
    const filterKeys = Object.keys(filter);
    return filterKeys.some((key) => {
      if (
        key === "page" ||
        key === "orderData" ||
        key === "search" ||
        key === "selectedUser"
      ) {
        return false;
      }

      const value = filter[key];

      // Check if value is empty array
      if (Array.isArray(value) && value.length === 0) {
        return false;
      }

      // Check if value is empty/null/undefined
      if (!value) {
        return false;
      }

      return true;
    });
  }, [filter]);

  async function getViews() {
    const { data } = await axios(
      `${apiUrl}/api/customerReport/${entityName}/views`
    );
    setViewList([
      { name: formatMessage({ id: "global.btn.allItems" }), value: "" },
      ...data,
    ]);
  }

  useEffect(() => {
    getViews();
  }, []);

  const handleCleanView = () => {
    setCurrentView({
      name: formatMessage({ id: "global.btn.allItems" }),
      value: "",
    });
  };

  const handleViewChange = async (view) => {
    setCurrentView(view); // 更新目前的 View
    await getViews(); // 重新抓取 Views
  };

  useEffect(() => {
    if (update === 0) return;
    if (currentView?.current?._id) {
      updateUserListFilter(currentView?.current?.filter);
    } else {
      updateUserListFilter(null);
    }
  }, [update]);

  return (
    <div>
      <Box className={"title fade-up"}>
        {formatMessage({ id: "global.function.customerAnalysis.title" })}
      </Box>
      <Box className="description fade-up" mb="24px">
        {formatMessage({ id: "global.function.customerAnalysis.description" })}
      </Box>
      <Box className="item-flex" mb="8px" gap="8px">
        <PopperMenu
          noBorder
          menuButtonContent={
            <>
              <i
                className="meta-crm-icon-ic_filter2 font-size-14"
                style={{ paddingRight: "5px" }}
              />
              {currentView?.current?.name ||
                formatMessage({ id: "global.btn.allItems" })}
              <Box borderRight="1px solid #E6E6E6" height="100%" mx="8px" />
              <i className="meta-crm-icon-ic_arrow-down font-size-14" />
            </>
          }
          menuItemGroup={[
            {
              menuItemTitle: formatMessage({ id: "global.view.views" }),
              menuItems: viewList.map((item) => ({
                ...item,
                label: item.name,
                value: item.name,
                checked: currentView?.current?.name === item?.name,
              })),
              canMultiSelect: false,
              onClick: (selected) => {
                setCurrentView(selected);
                setUpdate((prev) => prev + 1);
              },
            },
          ]}
        />
        <StyledFilterBtn
          onClick={() => {
            setOpenFilter(true);
          }}
        >
          <i className="meta-crm-icon-ic_filter2 font-size-14" />
          <Box ml="4px">{formatMessage({ id: "global.btn.filter" })}</Box>
        </StyledFilterBtn>
      </Box>

      <FilterList
        isReport
        hasFilter={hasFilter}
        currentView={currentView?.current}
        handleCleanView={handleCleanView}
        handleViewChange={handleViewChange}
        getViews={getViews}
        openFilterModal={() => setOpenFilter(true)}
      />
      <CustomerReport hasFilter={hasFilter} />
      {openFilter && (
        <FilterModal open={true} handleClose={() => setOpenFilter(false)} />
      )}
    </div>
  );
}
